import { render, staticRenderFns } from "./GoogleRegisterComponent.vue?vue&type=template&id=52d167f5&scoped=true"
import script from "./GoogleRegisterComponent.vue?vue&type=script&lang=js"
export * from "./GoogleRegisterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d167f5",
  null
  
)

export default component.exports